import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useSelector } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";

import HorizontalAssetList from "../../Shared/AssetPreviewList/HorizontalAssetList";
import AssetRotation from "./AssetRotation";
import AssetDelivery from "./AssetDelivery";
import DynamicTargetingKeys from "./DynamicTargetingKeys";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    // border: "1px solid rgba(0, 0, 0, 0.26)",
    boxShadow: "none",
    display: "flex",
    justifyContent: "space-around"
  },
  thumbsContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    width: "100%"
  },
  h6: {
    fontWeight: 400,
    fontSize: "1.15rem"
  }
}));

export default forwardRef(
  ({ isClickEnabled, isDragDisabled, isThumbnailEnabled }, ref) => {
    const classes = useStyles();

    const startDate = useSelector((state) => state.creatives.startDate);
    const endDate = useSelector((state) => state.creatives.endDate);
    const creatives = useSelector((state) => state.creatives);

    let [isDTKEnabled, setIsDTKEnabled] = useState(false);

    let RMTypes = [
      "RICH_MEDIA_DISPLAY_BANNER",
      "RICH_MEDIA_DISPLAY_EXPANDING",
      "RICH_MEDIA_DISPLAY_INTERSTITIAL"
    ];

    useEffect(() => {
      for (let creative of Object.values(creatives.byId)) {
        if (creative.dcmCreative) {
          if (RMTypes.includes(creative.dcmCreative.type)) {
            setIsDTKEnabled(true);
          }
        }
      }
    }, [creatives.byId, RMTypes])


    useImperativeHandle(ref, () => ({
      validate() {
        if (!startDate.isValid() || !endDate.isValid()) {
          return {
            hasErrors: true,
            message: "You need to specify start date and end date."
          };
        }

        return {
          hasErrors: false,
          message: ""
        };
      }
    }));

    return (
      <React.Fragment>
        <Typography variant="h6" className={classes.h6}>
          Select rotation type and weight
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <HorizontalAssetList
              isClickEnabled={isClickEnabled}
              isDragDisabled={isDragDisabled}
              isWeightEditable={true}
              isThumbnailEnabled={isThumbnailEnabled}
              isWeightEnabled={true}
            />
          </Grid>
          <Grid
            item
            xs={6}
            container
            direction="row"
            justify="space-around"
            alignItems="flex-start"
          >
            <AssetRotation />
            <AssetDelivery />
            {isDTKEnabled && <DynamicTargetingKeys />}
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
);
